const PRIMARY = {
  main: '#32D17D',
  light: '#EFFCF5',
  dark: '#272833'
};
const SECONDARY = {
  main: '#FAFAFA',
  light: '',
  dark: '#F5F5F5'
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '',
  darker: ''
};
const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#4289f4',
  dark: '',
  darker: ''
};
const WARNING = {
  lighter: '#FFF5EA',
  light: '#E0B878',
  main: '#f5bd50',
  dark: '',
  darker: ''
};
const ERROR = {
  lighter: '#FEEFEF',
  light: '#F48989',
  main: '#f65151',
  dark: '',
  darker: ''
};

const GREY = {
  disabled: '#E7E7ED',
  light: '#F3F2F1',
  main: '#8A8886',
  inActive: '#D2D0CE',
  innerBorder: '#CDCED9',
  secondary: '#605E5C'
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY
};

const palette = {
  ...COMMON,
  text: {
    primary: '#393A4A',
    secondary: '#6B6C7E',
    disabled: '#A7A9BC',
    tertiary: '#272833',
    accent: PRIMARY.main
  },
  background: {
    paper: '#fff',
    default: SECONDARY.main,
    neutral: GREY.disabled,
    primary: '#EFFCF5',
    secondary: '#E5E5E5',
    lighter: '#DEECF9'
  }
};

export default palette;
